var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / ES") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-ES",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DD172C",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DD172C",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFD133",
    mask: "url(#mask-2)",
    x: 0,
    y: 5.33333333,
    width: 28,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-139-Copy",
    fill: "#FFEDB1",
    mask: "url(#mask-2)",
    points: "7.33333333 9.33333333 8.66666667 9.33333333 8.66666667 10 7.33333333 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36054223,9.00165627 L8.44439251,11.3192353 C8.41969369,11.5790981 8.29982915,11.8150005 8.12340343,11.9939217 C7.94608483,12.1737485 7.71082751,12.2969932 7.45274305,12.3265124 C7.11673898,12.3258081 6.82210553,12.2174562 6.60386876,12.034672 C6.38541019,11.851702 6.24515646,11.5946793 6.22118675,11.3070428 L6.22118675,11.3070428 L6.07733827,9.58086102 L8.36054223,9.00165627 Z",
    id: "Rectangle-137",
    stroke: "#A41517",
    strokeWidth: 0.666666667,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-139",
    fill: "#A41517",
    mask: "url(#mask-2)",
    points: "6 10 8.66666667 10 8.66666667 10.6666667 8 10.6666667 7.33333333 12 6.66666667 10.6666667 6 10.6666667"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-135",
    fill: "#A41517",
    mask: "url(#mask-2)",
    x: 4,
    y: 8,
    width: 1.33333333,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-135-Copy",
    fill: "#A41517",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 8,
    width: 1.33333333,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7.33333333 C6,6.9651435 6.30590057,6.66666667 6.6729126,6.66666667 L7.99375407,6.66666667 C8.36539343,6.66666667 8.66666667,6.96257655 8.66666667,7.33333333 L8.66666667,7.6635437 C8.66666667,7.84936338 8.52329508,8 8.33968099,8 L6.32698568,8 C6.14639647,8 6,7.85730998 6,7.6635437 L6,7.33333333 Z",
    id: "Rectangle-138",
    fill: "#A41517",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.a4f8da3941541c4a06eb8693c65a3aff.svg";
export { ForwardRef as ReactComponent };